import React, { ReactNode } from "react";
import "../CSS/FAQExpandableSection.css";
import collapsedArrowIcon from "../../../assets/images/profile-collapsed-arrow-icon.svg";

interface FAQExpandableSectionProps {
  title: string;
  children: ReactNode;
  index: number;
  expanded: boolean;
  onToggle: () => void;
}

const FAQExpandableSection: React.FC<FAQExpandableSectionProps> = ({
  title,
  children,
  index,
  expanded,
  onToggle,
}) => {
  return (
    <div
      style={{ marginBottom: "10px" }}
      className={expanded ? "faq-main-container" : ""}
    >
      <div
        className={`faq-container ${expanded ? "expanded" : ""}`}
        onClick={onToggle}
        style={{ cursor: "pointer" }}
      >
        <div className="sub-conatiner">
          <div className="header-container">
            <span style={{ color: expanded ? "#FF6B35" : "white" }}>
              {index}.{" "}
            </span>
            <span style={{ color: expanded ? "#FF6B35" : "white" }}>
              {title}
            </span>
          </div>

          <div className="faq-expand-container">
            <img
              src={collapsedArrowIcon}
              alt="collapsed-arrow-icon"
              style={{
                transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            />
          </div>
        </div>

        <div className="divider"></div>
      </div>

      {expanded && <div className="faq-content">{children}</div>}
    </div>
  );
};

export default FAQExpandableSection;
